__turbopack_context__.v({
  "container": "style-module-scss-module__V-WA_q__container",
  "form-container": "style-module-scss-module__V-WA_q__form-container",
});
